import { NavLink, useParams } from 'react-router-dom';

import { NavigationLink } from 'app/layout/components/Layout/CoachSidebar/Navigation';
import {
  CHAT_WITH_AI_KNOWLEDGE_BASE_FEATURE_FLAG,
  MORPHEUS_OBJECTIVES_DASHBOARD_FEATURE_FLAG,
  RenderIfFFEnabled,
} from 'featureFlags';
import { VStack, Box, Avatar, Show } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import { HotjarSuppression } from 'shared_DEPRECATED/components/Hotjar';
import { iconNames } from 'shared_DEPRECATED/components/Icon';
import { Spacers } from 'shared_DEPRECATED/components/Spacer';
import { getPictureUrl } from 'shared_DEPRECATED/utils';
import { routeNames } from 'shared_DEPRECATED/utils/config';

import { useGoalsEnabled } from 'features/goal';
import { useParticipantQuery } from 'features/participants/hooks';
import { SprintInfoProgressCircle } from 'features/sprint/components/Info/ProgressCircle';
import { useLastSprint } from 'features/sprint/hooks/useLastSprint';
import { sharedSprintLinks } from 'features/sprint/utils';
import { useTimelineLink } from 'features/timeline/hooks/useTimelineLink';

export const CoachSidebarClosed = () => {
  const { email } = useParams();
  const { participant } = useParticipantQuery(email);
  const getNavigationLinkWithParticipantEmail = getNavigationLink(email!);
  const isGoalsEnabled = useGoalsEnabled();
  const lastSprint = useLastSprint();
  const sprintLink = useTimelineLink();

  return (
    <Box
    // data-state="closed"
    // _closed={{
    //   animation: 'fadeIn',
    // }}
    >
      <HotjarSuppression>
        <Flex
          as="span"
          justifyContent="flex-start"
          alignItems="center"
          gap="var(--spacing02)"
        >
          <Avatar
            name={participant.userName}
            size="md"
            src={getPictureUrl(participant.userPicture)}
          />
        </Flex>
      </HotjarSuppression>
      <Spacers sizes={['zr zr lg', 'zr zr md']} />
      <VStack gap={1} alignItems="flex-start">
        <RenderIfFFEnabled
          featureFlag={CHAT_WITH_AI_KNOWLEDGE_BASE_FEATURE_FLAG}
        >
          <NavigationLink
            iconConfig={{
              name: iconNames.hub,
            }}
            link={getNavigationLinkWithParticipantEmail('cortex-chat')}
            dataTestid="context-text-btn"
            title="Insights Chat"
          />
        </RenderIfFFEnabled>
        <NavigationLink
          iconConfig={{
            name: iconNames.dashboard,
          }}
          link={getNavigationLinkWithParticipantEmail('dashboard')}
          dataTestid="dashboard-bnt"
          title="Dashboard"
        />
        <NavigationLink
          iconConfig={{
            name: iconNames.sessions,
          }}
          link={getNavigationLinkWithParticipantEmail('sessions')}
          dataTestid="sessions-bnt"
          title="Sessions"
        />
        <RenderIfFFEnabled
          featureFlag={MORPHEUS_OBJECTIVES_DASHBOARD_FEATURE_FLAG}
        >
          <NavigationLink
            iconConfig={{
              name: iconNames.dashboard,
            }}
            link={getNavigationLinkWithParticipantEmail('objectives')}
            dataTestid="objectives-btn"
            title="Objectives"
          />
        </RenderIfFFEnabled>
        {isGoalsEnabled && (
          <NavigationLink
            iconConfig={{
              name: 'goals',
            }}
            link={getNavigationLinkWithParticipantEmail(routeNames.GOALS)}
            dataTestid="roadmap-navigation-goals-item"
            title="Goals"
          />
        )}
        <NavigationLink
          iconConfig={{
            name: 'planning',
          }}
          link={getNavigationLinkWithParticipantEmail(routeNames.PLANNING)}
          dataTestid="roadmap-navigation-planning-item"
          title="Planning"
        />
        <NavigationLink
          iconConfig={{
            name: iconNames.group,
          }}
          link={getNavigationLinkWithParticipantEmail('groups')}
          dataTestid="groups-btn"
          title="Groups"
        />
        <NavigationLink
          iconConfig={{
            name: iconNames.resource,
          }}
          link={getNavigationLinkWithParticipantEmail('resource-bank')}
          title="Resource bank"
          dataTestid="resources-btn"
        />
      </VStack>
      <Spacers sizes={['zr zr lg', 'zr zr md']} />
      <Box style={{ borderTop: 'var(--border-secondary)' }} />
      <Spacers sizes={['lg zr zr', 'md zr zr']} />
      <Show when={lastSprint}>
        {() => (
          <NavLink to={sprintLink}>
            <SprintInfoProgressCircle
              weekIndex={lastSprint.currentWeekNumber}
              successRate={lastSprint.successRate}
              status={lastSprint.state}
              weeksCount={lastSprint.weeksCount}
            />
          </NavLink>
        )}
      </Show>
    </Box>
  );
};

const getNavigationLink = (email: string) => (path: string) =>
  `${sharedSprintLinks.participants}/${email}/${path}`;
